import { request } from '@umijs/max';

/**
 * 获取租户列表
 */
export async function getTenants(params?: {
  page?: number;
  size?: number;
  code?: string;
  name?: string;
  is_active?: boolean;
}) {
  return request<API.ApiResult<API.PageData<API.Tenant>>>('/tenants', {
    method: 'GET',
    params,
  });
}

/**
 * 获取租户统计信息
 */
export async function getTenantStats() {
  return request<API.ApiResult<API.TenantStats[]>>('/tenants/stats', {
    method: 'GET',
  });
}

/**
 * 获取租户下拉选项
 */
export async function getTenantOptions() {
  return request<API.ApiResult<API.TenantOption[]>>('/tenants/options', {
    method: 'GET',
  });
}

/**
 * 获取租户详情
 */
export async function getTenant(id: number) {
  return request<API.ApiResult<API.Tenant>>(`/tenants/${id}`, {
    method: 'GET',
  });
}

/**
 * 创建租户
 */
export async function createTenant(data: API.TenantCreate) {
  return request<API.ApiResult<API.Tenant>>('/tenants', {
    method: 'POST',
    data,
  });
}

/**
 * 更新租户
 */
export async function updateTenant(id: number, data: API.TenantUpdate) {
  return request<API.ApiResult<API.Tenant>>(`/tenants/${id}`, {
    method: 'PUT',
    data,
  });
}

/**
 * 删除租户
 */
export async function deleteTenant(id: number) {
  return request<API.ApiResult<void>>(`/tenants/${id}`, {
    method: 'DELETE',
  });
}

/**
 * 切换租户视角（系统管理员）
 */
export async function switchTenantView(tenantId: number) {
  return request<API.ApiResult<{
    tenant_id: number;
    tenant_code: string;
    tenant_name: string;
  }>>(`/tenants/${tenantId}/switch`, {
    method: 'POST',
  });
}

/**
 * 清除租户视角切换（系统管理员）
 */
export async function clearTenantView() {
  return request<API.ApiResult<void>>('/tenants/switch/clear', {
    method: 'POST',
  });
}

/**
 * 切换租户启用状态
 */
export async function toggleTenantActive(id: number) {
  return request<API.ApiResult<API.Tenant>>(`/tenants/${id}/toggle-active`, {
    method: 'PUT',
  });
}
